export default __webpack_public_path__ + "1af7cdd8da00573d893f873f2394898c.ttf";